import React, { useContext } from "react";
import { Box } from "@mui/material";

import HomeInfo from "./HomeInfo";
import ChartDia from "./homeInfoComponents/ChartDia";
import MoraByGestor from "./homeInfoComponents/MoraByGestor";
import ClientsByLocation from "./clientComponents/ClientsByLocation";
import CreditsByPeriodicidad from "./clientComponents/CreditsByPeriodicidad";
import RankingGestores from "./clientComponents/RankingGestores";
import ColocacionSemanal from "./homeInfoComponents/ColocacionSemanal";
import FlujoCaja from "./homeInfoComponents/FlujoCaja";
import SectionCard from "../../components/ui/SectionCard";
import { DataContext } from "../../context/DataContext";

// Dashboard — ver design_handoff_crediapp_redesign/Dashboard CrediApp.dc.html.
// La sucursal ya no se elige aqui: vive en el topbar global (SucursalSelector)
// sobre DataContext.selectedSucursal, como pide el README del handoff.
const HomeContainer = () => {
  const { selectedSucursal } = useContext(DataContext);

  if (selectedSucursal === 0) {
    return null;
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "18px" }}>
      <HomeInfo selectedSucursal={selectedSucursal} />

      <SectionCard
        title="Colocación vs recuperación"
        subtitle="Efectivo colocado y recuperado por día · Lunes a domingo"
      >
        <Box sx={{ height: 300, position: "relative", marginTop: "8px" }}>
          <FlujoCaja selectedSucursal={selectedSucursal} />
        </Box>
      </SectionCard>

      <SectionCard
        title="Colocación semanal"
        subtitle="Monto desembolsado por día · Lunes a domingo"
      >
        <Box sx={{ height: 280, position: "relative", marginTop: "8px" }}>
          <ColocacionSemanal selectedSucursal={selectedSucursal} />
        </Box>
      </SectionCard>

      {/* Las dos distribuciones van juntas y sin altura fija: son listas de
          barras, no graficos, y crecen con la cantidad de categorias. */}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
          gap: "18px",
          alignItems: "start",
        }}
      >
        <SectionCard
          title="Créditos por periodicidad"
          subtitle="Distribución de créditos activos"
        >
          <Box sx={{ marginTop: "14px" }}>
            <CreditsByPeriodicidad selectedSucursal={selectedSucursal} />
          </Box>
        </SectionCard>

        <SectionCard
          title="Clientes por municipio"
          subtitle="Distribución geográfica de la cartera"
        >
          <Box sx={{ marginTop: "14px" }}>
            <ClientsByLocation selectedSucursal={selectedSucursal} />
          </Box>
        </SectionCard>
      </Box>

      {/* Los tres bloques de gestores juntos: el ranking es una lista y crece
          poco, asi que comparte fila con la recuperacion. */}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "2fr 1fr" },
          gap: "18px",
          alignItems: "start",
        }}
      >
        <SectionCard
          title="Recuperación por gestor"
          subtitle="Monto cobrado en el día · Córdobas"
        >
          <Box sx={{ height: 250, position: "relative", marginTop: "8px" }}>
            <ChartDia selectedSucursal={selectedSucursal} />
          </Box>
        </SectionCard>

        <SectionCard
          title="Ranking de gestores"
          subtitle="Top 5 por colocación del mes"
        >
          <Box sx={{ marginTop: "16px" }}>
            <RankingGestores selectedSucursal={selectedSucursal} />
          </Box>
        </SectionCard>
      </Box>

      <SectionCard title="Mora por gestor" subtitle="Saldo en mora acumulado">
        <Box sx={{ height: 250, position: "relative", marginTop: "8px" }}>
          <MoraByGestor selectedSucursal={selectedSucursal} />
        </Box>
      </SectionCard>
    </Box>
  );
};

export default HomeContainer;
